/* sugar:assets/section-divider.js@2.0.0 */
/**
 * Section divider — colour matching against the sections above and below.
 *
 * One copy of this file serves every divider on the page. The markup carries
 * data attributes only, so nothing here depends on a class name:
 *
 *   [data-sd-auto]     a divider set to match its neighbours
 *   [data-sd-flip-v]   the divider is flipped, so "above" and "below" swap
 *   [data-sd-smil]     an svg whose motion is an <animateTransform>, which a media query
 *                      cannot reach — the reduced-motion preference is honoured here instead
 *
 * The neighbours are read through section-neighbors.js, which must load first. Two custom
 * properties are written back onto the divider: --sd-bg is the colour of the section it
 * sits under, --sd-fill the colour of the section it points at. The stylesheet reads both,
 * so nothing here touches the shape itself. A shape can only hold one flat colour, so a
 * gradient neighbour contributes the colour it shows along the shared edge.
 */

(function () {
  'use strict';

  if (window.SugarSectionDivider) return;

  function paint(sec) {
    var N = window.SugarSectionNeighbors;
    if (!N) return;
    var wrap = sec.closest('.shopify-section');
    if (!wrap) return;

    var flipped = sec.hasAttribute('data-sd-flip-v');
    var bg = flipped ? N.below(wrap) : N.above(wrap);
    var fill = flipped ? N.above(wrap) : N.below(wrap);

    if (bg) sec.style.setProperty('--sd-bg', bg.color);
    if (fill) sec.style.setProperty('--sd-fill', fill.color);
  }

  /**
   * `animation: none` in a media query only reaches CSS animations, so an SVG driven by
   * <animateTransform> has to be stopped through its own timeline. Pausing parks it on the
   * resting shape, which is exactly what the un-animated divider renders.
   */
  function holdStill() {
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var svgs = document.querySelectorAll('[data-sd-smil]');
    for (var i = 0; i < svgs.length; i++) {
      if (svgs[i].pauseAnimations) svgs[i].pauseAnimations();
    }
  }

  function update() {
    var all = document.querySelectorAll('[data-sd-auto]');
    for (var i = 0; i < all.length; i++) paint(all[i]);
    holdStill();
  }

  function init() {
    update();
    // A neighbour whose own script paints its background settles a tick later.
    setTimeout(update, 100);
  }

  window.SugarSectionDivider = { update: update };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:unload', update);
  document.addEventListener('shopify:section:reorder', update);
})();
